import { defineComponent as _defineComponent } from 'vue'

import BaseText from "@/components-UI/BaseText.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgCopy from "@/assets/icons/copy.svg";
import { useCopyText } from "@/utils/copyText";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseGreyBacking',
  props: {
    text: null,
    maxWidth: null,
    minWidth: null,
    lineClamp: null,
    isEllipsis: { type: Boolean },
    isUnderline: { type: Boolean },
    customClass: null,
    isStrikethrough: { type: Boolean },
    isCopy: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    text?: string,
    maxWidth?: string,
    minWidth?: string,
    lineClamp?: number | string,
    isEllipsis?: boolean,
    isUnderline?: boolean,
    customClass?: string,
    isStrikethrough?: boolean,
    isCopy?: boolean,
}



const handleClickCopyButton = (): void => {
    if (props.text) {
        useCopyText(props.text);
    }
};

return { __sfc: true,props, handleClickCopyButton, BaseText, BaseButton, SvgCopy }
}

})